import { render, staticRenderFns } from "./courseSelectDialog.vue?vue&type=template&id=003cbf35"
import script from "./courseSelectDialog.vue?vue&type=script&lang=js"
export * from "./courseSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./courseSelectDialog.vue?vue&type=style&index=0&id=003cbf35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports